import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface ClutchFluidProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function ClutchFluid(props: ClutchFluidProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 96, left: 236}}
      onClick={props.onClick}
    >
      <circle
        cx="9"
        cy="9"
        r="8"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></circle>
      <circle
        cx="9"
        cy="9"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M14.3333 8.99984L11.6667 13.6186L6.33334 13.6186L3.66668 8.99984L6.33334 4.38103L11.6667 4.38104L14.3333 8.99984Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
